(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3195],{

/***/ 14136:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners",
      function () {
        return __webpack_require__(89361);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PartnersListSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var PartnersListSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PARTNERS */ .Z.PARTNERS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PartnersListSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 89361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_partners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/layout/Layout.js + 36 modules
var Layout = __webpack_require__(49807);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/partners.js
var partners = __webpack_require__(9491);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/partners/Partners-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from{\n		transform: translateX(80%);\n	}\n	to{\n		transform: translateX(0);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from{\n		transform: translateX(-80%);\n	}\n	to{\n		transform: translateX(0);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  from{\n    opacity: 0;\n    transform: translateY(150%);\n  }\n  to{\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 5px solid #3bb77e;\n  width: 70px;\n  margin-top: 15px;\n  margin: 0 auto;\n  margin-bottom: 50px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        '\n  /* background-image: url("/assets/imgs/page/partners/main_bg.jpg");\n  background-position: center center;\n  background-repeat: no-repeat; */\n  width: 100vw;\n  /* height: 600px; */\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  margin-bottom: 50px;\n  & img {\n    min-height: 300px;\n    min-width: 1000px;\n    margin: 0 auto;\n  }\n  & div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    font-size: 3rem;\n    & h2 {\n      font-size: 3rem;\n      color: #fff;\n      :nth-of-type(1) {\n        margin-right: 10px;\n        animation: ',
        " 1.5s ease-in-out alternate;\n      }\n      :nth-of-type(2) {\n        color: #31ffa0;\n        margin-right: 10px;\n        animation: ",
        " 1.5s ease-in-out alternate;\n      }\n      :nth-of-type(3) {\n        animation: ",
        " 1.5s ease-in-out alternate;\n      }\n    }\n  }\n  @media (max-width: 1200px) {\n    & div {\n      & h2 {\n        font-size: 40px;\n      }\n    }\n  }\n  @media (max-width: 991px) {\n    & div {\n      & h2 {\n        font-size: 36px;\n      }\n    }\n  }\n  @media (max-width: 767px) {\n    & div {\n      & h2 {\n        font-size: 32px;\n      }\n    }\n  }\n  @media (max-width: 575px) {\n    & div {\n      background-color: rgba(0, 0, 0, 0.2);\n      flex-direction: column;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 30px;\n  padding-bottom: 50px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 575px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  overflow: hidden;\n  /* cursor: pointer; */\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var MoveXL = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var MoveXR = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var MoveY = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-430a95cb-0"
})(_templateObject3());
var CommonUnderBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-430a95cb-1"
})(_templateObject4());
// 상단
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-430a95cb-2"
})(_templateObject5(), MoveXL, MoveY, MoveXR);
var GridWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-430a95cb-3"
})(_templateObject6());
var ImgBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-430a95cb-4"
})(_templateObject7());

;// CONCATENATED MODULE: ./components/partners/Partners-container.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






var Partners = function() {
    var ref2 = (0,react.useState)(""), partnersList = ref2[0], setPartnersList = ref2[1];
    var fetchPartners = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,partners/* PartnersListSet */.d)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setPartnersList((ref = res.Data) === null || ref === void 0 ? void 0 : ref.rows);
                        } else {
                            ;
                            console.error(res === null || res === void 0 ? void 0 : (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchPartners() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchPartners();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/imgs/page/partners/main_bg.jpg",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "\uBBF8\uB798\uC758 \uB2F9\uC5F0\uD568\uC744"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "[\uACE0\uAC1D\uC0AC\uC640 \uD568\uAED8]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "\uB9CC\uB4E4\uB2E4"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonUnderBar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrapper, {
                    className: "container",
                    children: partnersList !== undefined && partnersList.length > 0 && partnersList.map(function(el, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "default-img",
                                src: el.img_url,
                                alt: el.img_alt
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Partners_container = (Partners);

// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/partners/index.js




var PartnersPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uACE0\uAC1D\uC0AC",
            pageTitle: SeoMeta/* SeoMeta.customerCompanies.title */.e.customerCompanies.title,
            pageDesc: SeoMeta/* SeoMeta.customerCompanies.description */.e.customerCompanies.description,
            pageKeyword: SeoMeta/* SeoMeta.customerCompanies.keywords */.e.customerCompanies.keywords,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners_container, {})
        })
    });
};
/* harmony default export */ var pages_partners = (PartnersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,9807,4027,9774,2888,179], function() { return __webpack_exec__(14136); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);